import React from "react";
// https://fluentsite.z22.web.core.windows.net/quick-start
import { Provider, teamsTheme, Loader } from "@fluentui/react-northstar";
import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { useTeamsFx } from "./sample/lib/useTeamsFx";
import { IntlProvider } from "react-intl";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import "./App.css";
import "../assets/main.css";
import "./PostTailwind.css"; //  <==  PostTailwind.css comes after main.css to over write tailwind setitings for teams dark mode
import TabConfig from "./TabConfig";
import { About } from "./About";
import Recognition from "./Recognition";
import Auth from "./auth/Auth";
import HealthCheck from "./HealthCheck";
import ErrorBoundary from "./ErrorBoundary";
import AuthorizedRoute from "./AuthorizedRoute";

import { debugLog } from "../util/debug";
import AuthStart from "./auth/AuthStart";
import AuthEnd from "./auth/AuthEnd";
import { UseGlobalState } from "../state/gsh/gsh";
import { SetBranding } from "../util/branding";
import TabHome from "./tab/TabHome";
import TabRedirect from "./tab/TabDirect";
import TabShop from "./tab/TabShop";
import ja_JP from "../lang/ja_JP.json";

require("dotenv").config();

export default function App() {
  const { theme, loading } = useTeamsFx();
  const [state, setState] = UseGlobalState();

  React.useEffect(() => {
    debugLog("App base useEffect");

    if (!state.messagesLoader) {
      state.messagesLoader = {
        "cs-CZ": () => import("../lang/cs_CZ.json"),
        "de-DE": () => import("../lang/de_DE.json"),
        "el-GR": () => import("../lang/el_GR.json"),
        "en-GB": () => import("../lang/en_GB.json"),
        "en-US": () => import("../lang/en_US.json"),
        "es-ES": () => import("../lang/es_ES.json"),
        "es-MX": () => import("../lang/es_MX.json"),
        "fr-CA": () => import("../lang/fr_CA.json"),
        "fr-FR": () => import("../lang/fr_FR.json"),
        "hi-IN": () => import("../lang/hi_IN.json"),
        "hu-HU": () => import("../lang/hu_HU.json"),
        "it-IT": () => import("../lang/it_IT.json"),
        "ja-JP": () => import("../lang/ja_JP.json"),
        "ko-KR": () => import("../lang/ko_KR.json"),
        "nl-NL": () => import("../lang/nl_NL.json"),
        "pl-PL": () => import("../lang/pl_PL.json"),
        "pt-BR": () => import("../lang/pt_BR.json"),
        "pt-PT": () => import("../lang/pt_PT.json"),
        "ru-RU": () => import("../lang/ru_RU.json"),
        "sl-SI": () => import("../lang/sl_SI.json"),
        "tr-TR": () => import("../lang/tr_TR.json"),
        "zh-CN": () => import("../lang/zh_CN.json"),
        "zh-TW": () => import("../lang/zh_TW.json"),
      };
      setState(state);
    }

    if (!state.currentLocale) {
      state.currentLocale = "en-US";
      setState(state);
    }

    state.messagesLoader[state.currentLocale]().then((translations) => {
      state.messages = translations;
      setState(state);
    });

    if (!state.isBrandingSet) {
      if (SetBranding()) {
        state.isBrandingSet = true;
        setState(state);
      }
    }

    // eslint-disable-next-line
  }, []);

  return (
    <IntlProvider
      key={state.currentLocale}
      messages={state.messages}
      locale={state.currentLocale}
    >
      <Provider theme={theme || teamsTheme}>
        <ErrorBoundary>
          <Router>
            {loading ? (
              <Loader style={{ margin: 100 }} />
            ) : (
              <Switch>
                {/* Core components for tabs app behavior */}
                <AuthorizedRoute exact path="/" component={Auth} />
                <AuthorizedRoute path="/recognition" component={Recognition} />

                {/* For kubernetes monitoring.  The exernal URL is /#/health-check (HashRouter). There is bot code
              that forward /health-check here. */}
                <Route exact path="/health-check" component={HealthCheck} />

                {/* presently using in manifest - DONT WORK - show an error when called directly*/}
                <Route path="/privacy" component={Privacy} />
                <Route path="/termsofuse" component={TermsOfUse} />

                {/* presently not using in manifest - work, but show non-useful information*/}
                <Route path="/config" component={TabConfig} />
                <Route path="/about" component={About} />

                <Route path="/tabHome" component={TabHome} />
                <Route path="/tabShop" component={TabShop} />
                <Route path="/tabdirect" component={TabRedirect} />

                {/* MS Authentication */}
                <Route path="/auth-start/:teamsOauthUrl" component={AuthStart} />
                <Route path="/maritz-sso" component={AuthEnd} />

                <Redirect to="/" />
              </Switch>
            )}
          </Router>
        </ErrorBoundary>
      </Provider>
    </IntlProvider>
  );
}
